module.exports = __webpack_public_path__ + "img/syukyaku-sytem-pa001.ce01105b.png";